// FontAwesome icons

// Use plugins to only use the features we need
// Old import: import { config, dom, library } from 'Vendor/@fortawesome/fontawesome-svg-core'
// Docs: https://fontawesome.com/docs/apis/javascript/plugins
import {
	InjectCSS,
	Layers,
	// LayersCounter,
	// LayersText,
	// Masks,
	MutationObserver,
	PowerTransforms,
	register,
	ReplaceElements,
} from 'Vendor/@fortawesome/fontawesome-svg-core/plugins.mjs';

const api = register([
	InjectCSS,
	Layers,
	// LayersCounter,
	// LayersText,
	// Masks,
	MutationObserver,
	PowerTransforms,
	ReplaceElements,
])

api.config.autoReplaceSvg = 'nest';
api.config.observeMutations = true;

// Solid icons
import { faAngleLeft            } from 'Vendor/@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight           } from 'Vendor/@fortawesome/free-solid-svg-icons/faAngleRight';
import { faAnglesUp             } from 'Vendor/@fortawesome/free-solid-svg-icons/faAnglesUp';
import { faAsterisk             } from 'Vendor/@fortawesome/free-solid-svg-icons/faAsterisk';
import { faBars                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faBars';
import { faBasketShopping       } from 'Vendor/@fortawesome/free-solid-svg-icons/faBasketShopping';
import { faBold                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faBold';
import { faBriefcase            } from 'Vendor/@fortawesome/free-solid-svg-icons/faBriefcase';
import { faBullhorn             } from 'Vendor/@fortawesome/free-solid-svg-icons/faBullhorn';
import { faCalculator           } from 'Vendor/@fortawesome/free-solid-svg-icons/faCalculator';
import { faCalendarDays         } from 'Vendor/@fortawesome/free-solid-svg-icons/faCalendarDays';
import { faCaretDown            } from 'Vendor/@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretUp              } from 'Vendor/@fortawesome/free-solid-svg-icons/faCaretUp';
import { faChartLine            } from 'Vendor/@fortawesome/free-solid-svg-icons/faChartLine';
import { faChartPie             } from 'Vendor/@fortawesome/free-solid-svg-icons/faChartPie';
import { faCheck                } from 'Vendor/@fortawesome/free-solid-svg-icons/faCheck';
import { faChild                } from 'Vendor/@fortawesome/free-solid-svg-icons/faChild';
import { faCircle               } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircle';
import { faCircleArrowUp        } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleArrowUp';
import { faCircleArrowDown      } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleArrowDown';
import { faCircleCheck          } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleCheck';
import { faCircleDot            } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleDot';
import { faCircleExclamation    } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleExclamation';
import { faCircleInfo           } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faCircleMinus          } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleMinus';
import { faCirclePlus           } from 'Vendor/@fortawesome/free-solid-svg-icons/faCirclePlus';
import { faCircleQuestion       } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faCircleXmark          } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleXmark';
import { faClock                } from 'Vendor/@fortawesome/free-solid-svg-icons/faClock';
import { faClockRotateLeft      } from 'Vendor/@fortawesome/free-solid-svg-icons/faClockRotateLeft';
import { faCloudArrowUp         } from 'Vendor/@fortawesome/free-solid-svg-icons/faCloudArrowUp';
import { faCommentDots          } from 'Vendor/@fortawesome/free-solid-svg-icons/faCommentDots';
import { faCompress             } from 'Vendor/@fortawesome/free-solid-svg-icons/faCompress';
import { faCopy                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faCopy';
import { faCreditCard           } from 'Vendor/@fortawesome/free-solid-svg-icons/faCreditCard';
import { faDownload             } from 'Vendor/@fortawesome/free-solid-svg-icons/faDownload';
import { faEarthAfrica          } from 'Vendor/@fortawesome/free-solid-svg-icons/faEarthAfrica';
import { faEnvelope             } from 'Vendor/@fortawesome/free-solid-svg-icons/faEnvelope';
import { faFileArrowUp          } from 'Vendor/@fortawesome/free-solid-svg-icons/faFileArrowUp';
import { faFileCsv              } from 'Vendor/@fortawesome/free-solid-svg-icons/faFileCsv';
import { faFileExcel            } from 'Vendor/@fortawesome/free-solid-svg-icons/faFileExcel';
import { faFilePdf              } from 'Vendor/@fortawesome/free-solid-svg-icons/faFilePdf';
import { faFlag                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faFlag';
import { faFutbol               } from 'Vendor/@fortawesome/free-solid-svg-icons/faFutbol';
import { faGear                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faGear';
import { faGears                } from 'Vendor/@fortawesome/free-solid-svg-icons/faGears';
import { faGraduationCap        } from 'Vendor/@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faHandshakeAngle       } from 'Vendor/@fortawesome/free-solid-svg-icons/faHandshakeAngle';
import { faHeading              } from 'Vendor/@fortawesome/free-solid-svg-icons/faHeading';
import { faHeart                } from 'Vendor/@fortawesome/free-solid-svg-icons/faHeart';
import { faHelicopter           } from 'Vendor/@fortawesome/free-solid-svg-icons/faHelicopter';
import { faHouse                } from 'Vendor/@fortawesome/free-solid-svg-icons/faHouse';
import { faIdCard               } from 'Vendor/@fortawesome/free-solid-svg-icons/faIdCard';
import { faImage                } from 'Vendor/@fortawesome/free-solid-svg-icons/faImage';
import { faImages               } from 'Vendor/@fortawesome/free-solid-svg-icons/faImages';
import { faItalic               } from 'Vendor/@fortawesome/free-solid-svg-icons/faItalic';
import { faLeaf                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faLeaf';
import { faLink                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faLink';
import { faList                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faList';
import { faListOl               } from 'Vendor/@fortawesome/free-solid-svg-icons/faListOl';
import { faLock                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faLock';
import { faMagnifyingGlass      } from 'Vendor/@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassMinus } from 'Vendor/@fortawesome/free-solid-svg-icons/faMagnifyingGlassMinus';
import { faMagnifyingGlassPlus  } from 'Vendor/@fortawesome/free-solid-svg-icons/faMagnifyingGlassPlus';
import { faMedal                } from 'Vendor/@fortawesome/free-solid-svg-icons/faMedal';
import { faMinus                } from 'Vendor/@fortawesome/free-solid-svg-icons/faMinus';
import { faMobileScreenButton   } from 'Vendor/@fortawesome/free-solid-svg-icons/faMobileScreenButton';
import { faMoneyBill            } from 'Vendor/@fortawesome/free-solid-svg-icons/faMoneyBill';
import { faPalette              } from 'Vendor/@fortawesome/free-solid-svg-icons/faPalette';
import { faPaw                  } from 'Vendor/@fortawesome/free-solid-svg-icons/faPaw';
import { faPencil               } from 'Vendor/@fortawesome/free-solid-svg-icons/faPencil';
import { faPersonRunning        } from 'Vendor/@fortawesome/free-solid-svg-icons/faPersonRunning';
import { faPhone                } from 'Vendor/@fortawesome/free-solid-svg-icons/faPhone';
import { faPiggyBank            } from 'Vendor/@fortawesome/free-solid-svg-icons/faPiggyBank';
import { faPlaceOfWorship       } from 'Vendor/@fortawesome/free-solid-svg-icons/faPlaceOfWorship';
import { faPlus                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faPlus';
import { faQrcode               } from 'Vendor/@fortawesome/free-solid-svg-icons/faQrcode';
import { faQuoteLeft            } from 'Vendor/@fortawesome/free-solid-svg-icons/faQuoteLeft';
import { faQuoteRight           } from 'Vendor/@fortawesome/free-solid-svg-icons/faQuoteRight';
import { faRightFromBracket     } from 'Vendor/@fortawesome/free-solid-svg-icons/faRightFromBracket';
import { faRightToBracket       } from 'Vendor/@fortawesome/free-solid-svg-icons/faRightToBracket';
import { faRotate               } from 'Vendor/@fortawesome/free-solid-svg-icons/faRotate';
import { faRotateLeft           } from 'Vendor/@fortawesome/free-solid-svg-icons/faRotateLeft';
import { faRotateRight          } from 'Vendor/@fortawesome/free-solid-svg-icons/faRotateRight';
import { faShareNodes           } from 'Vendor/@fortawesome/free-solid-svg-icons/faShareNodes';
import { faSitemap              } from 'Vendor/@fortawesome/free-solid-svg-icons/faSitemap';
import { faSpinner              } from 'Vendor/@fortawesome/free-solid-svg-icons/faSpinner';
import { faStar                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faStar';
import { faStarHalfStroke       } from 'Vendor/@fortawesome/free-solid-svg-icons/faStarHalfStroke';
import { faSterlingSign         } from 'Vendor/@fortawesome/free-solid-svg-icons/faSterlingSign';
import { faStethoscope          } from 'Vendor/@fortawesome/free-solid-svg-icons/faStethoscope';
import { faTags                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faTags';
import { faThumbsUp             } from 'Vendor/@fortawesome/free-solid-svg-icons/faThumbsUp';
import { faTrashCan             } from 'Vendor/@fortawesome/free-solid-svg-icons/faTrashCan';
import { faTrophy               } from 'Vendor/@fortawesome/free-solid-svg-icons/faTrophy';
import { faUpRightFromSquare    } from 'Vendor/@fortawesome/free-solid-svg-icons/faUpRightFromSquare';
import { faUser                 } from 'Vendor/@fortawesome/free-solid-svg-icons/faUser';
import { faUserGear             } from 'Vendor/@fortawesome/free-solid-svg-icons/faUserGear';
import { faUsers                } from 'Vendor/@fortawesome/free-solid-svg-icons/faUsers';
import { faUsersGear            } from 'Vendor/@fortawesome/free-solid-svg-icons/faUsersGear';
import { faVideo                } from 'Vendor/@fortawesome/free-solid-svg-icons/faVideo';
import { faWheelchair           } from 'Vendor/@fortawesome/free-solid-svg-icons/faWheelchair';
import { faXmark                } from 'Vendor/@fortawesome/free-solid-svg-icons/faXmark';

api.library.add({
	faAngleLeft,
	faAngleRight,
	faAnglesUp,
	faAsterisk,
	faBars,
	faBasketShopping,
	faBold,
	faBriefcase,
	faBullhorn,
	faCalculator,
	faCalendarDays,
	faCaretDown,
	faCaretUp,
	faChartLine,
	faChartPie,
	faCheck,
	faChild,
	faCircle,
	faCircleArrowUp,
	faCircleArrowDown,
	faCircleCheck,
	faCircleDot,
	faCircleExclamation,
	faCircleInfo,
	faCircleMinus,
	faCirclePlus,
	faCircleQuestion,
	faCircleXmark,
	faClock,
	faClockRotateLeft,
	faCloudArrowUp,
	faCommentDots,
	faCompress,
	faCopy,
	faCreditCard,
	faDownload,
	faEarthAfrica,
	faEnvelope,
	faFileArrowUp,
	faFileCsv,
	faFileExcel,
	faFilePdf,
	faFlag,
	faFutbol,
	faGear,
	faGears,
	faGraduationCap,
	faHandshakeAngle,
	faHeading,
	faHeart,
	faHelicopter,
	faHouse,
	faIdCard,
	faImage,
	faImages,
	faItalic,
	faLeaf,
	faLink,
	faList,
	faListOl,
	faLock,
	faMagnifyingGlass,
	faMagnifyingGlassMinus,
	faMagnifyingGlassPlus,
	faMedal,
	faMinus,
	faMobileScreenButton,
	faMoneyBill,
	faPalette,
	faPaw,
	faPencil,
	faPersonRunning,
	faPhone,
	faPiggyBank,
	faPlaceOfWorship,
	faPlus,
	faQrcode,
	faQuoteLeft,
	faQuoteRight,
	faRightFromBracket,
	faRightToBracket,
	faRotate,
	faRotateLeft,
	faRotateRight,
	faShareNodes,
	faSitemap,
	faSpinner,
	faStar,
	faStarHalfStroke,
	faSterlingSign,
	faStethoscope,
	faTags,
	faThumbsUp,
	faTrashCan,
	faTrophy,
	faUpRightFromSquare,
	faUser,
	faUserGear,
	faUsers,
	faUsersGear,
	faVideo,
	faWheelchair,
	faXmark,
})

// Regular icons

import { faCircle      as farCircle      } from 'Vendor/@fortawesome/free-regular-svg-icons/faCircle';
import { faCircleCheck as farCheckCircle } from 'Vendor/@fortawesome/free-regular-svg-icons/faCircleCheck';

api.library.add({
	farCheckCircle,
	farCircle,
})

// Brand icons
import { faFacebook          } from 'Vendor/@fortawesome/free-brands-svg-icons/faFacebook';
import { faBluesky           } from 'Vendor/@fortawesome/free-brands-svg-icons/faBluesky';
import { faFacebookF         } from 'Vendor/@fortawesome/free-brands-svg-icons/faFacebookF';
import { faFacebookMessenger } from 'Vendor/@fortawesome/free-brands-svg-icons/faFacebookMessenger';
import { faInstagram         } from 'Vendor/@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn        } from 'Vendor/@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faStrava            } from 'Vendor/@fortawesome/free-brands-svg-icons/faStrava';
import { faStripe            } from 'Vendor/@fortawesome/free-brands-svg-icons/faStripe';
import { faThreads           } from 'Vendor/@fortawesome/free-brands-svg-icons/faThreads';
import { faWhatsapp          } from 'Vendor/@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faXTwitter          } from 'Vendor/@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYoutube           } from 'Vendor/@fortawesome/free-brands-svg-icons/faYoutube';

api.library.add({
	faBluesky,
	faFacebook,
	faFacebookF,
	faFacebookMessenger,
	faInstagram,
	faLinkedinIn,
	faStrava,
	faStripe,
	faThreads,
	faWhatsapp,
	faXTwitter,
	faYoutube,
});

// Replace and watch
api.dom.i2svg();
api.dom.watch();